import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Estimator from "./pages/Estimator";
import GuidedPlanner from "./pages/GuidedPlanner";
import DetailedPlanner from "./pages/DetailedPlanner";
import VideoLibrary from "./pages/VideoLibrary";
import { ThemeProvider } from "./context/ThemeContext";
import "./styles/global.css";

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/estimator" element={<Estimator />} />
          <Route path="/guided-planner" element={<GuidedPlanner />} />
          <Route path="/detailed-planner" element={<DetailedPlanner />} />
          <Route path="/videos" element={<VideoLibrary />} />
          {/* Catch-all: any URL we don't have a route for sends the user
              home. `replace` swaps the bad URL out of history so the
              browser back-button doesn't loop them back into the redirect. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}